<template>
  <div class="modal fade" id="add-vpn" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <LoadingElement v-if="loading" />
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-vpn-close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-primary">
              {{ $t("vpns.vpn_connection") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />
          <div class="row">
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("vpns.username")
              }}</label>
              <input
                @input="validate"
                type="text"
                class="form-control"
                :disabled="prop_vpn"
                v-model="selectedVpn.username"
                :class="{ 'ring-1 ring-red-500': errors.username }"
              />
              <div class="text-danger" v-if="errors.username">
                {{ errors.username }}
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("vpns.password")
              }}</label>
              <input
                @input="validate"
                type="text"
                class="form-control"
                v-model="selectedVpn.password"
                :class="{ 'ring-1 ring-red-500': errors.password }"
              />
              <div class="text-danger" v-if="errors.password">
                {{ errors.password }}
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("vpns.ip")
              }}</label>
              <input
                type="text"
                class="form-control"
                @input="validate"
                v-model="selectedVpn.ip"
                :class="{ 'ring-1 ring-red-500': errors.ip }"
              />
              <div class="text-danger" v-if="errors.ip">
                {{ errors.ip }}
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("vpns.service")
              }}</label>
              <select class="form-select" v-model="selectedVpn.service">
                <option value="pptpd">PPTP</option>
                <option value="xl2tpd">L2TP</option>
                <option value="*">{{ $t("control.all") }}</option>
              </select>
            </div>

            <div
              class="col-12 text-danger"
              v-for="(item, index) in server_errors"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div class="row mt-4">
            <div class="flex justify-center">
              <button
                class="btn btn-primary"
                :disabled="loading || !validated"
                @click="store"
              >
                {{ $t("control.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "VpnAddModal",
  props: {
    vpn: {
      type: Object,
      required: false,
    },
  },
  created() {
    this.prop_vpn = false;
    if (this.vpn.username) {
      this.selectedVpn = this.vpn;
      this.prop_vpn = true;
    }
  },
  data() {
    return {
      loading: false,
      selectedVpn: {
        id: null,
        username: null,
        password: null,
        ip: null,
        service: "pptpd",
      },
      errors: {
        username: null,
        password: null,
        ip: null,
      },
      validated: false,
      prop_vpn: false,
      server_errors: null,
    };
  },
  methods: {
    async store() {
      this.loading = true;
      try {
        if (this.prop_vpn) {
          const response = await axios.post(
            "localvpn/update",
            this.selectedVpn,
          );
          if (response.status === 200) {
            document.getElementById("add-vpn-close").click();
            this.$notify({
              text: this.$t("vpns.vpn_updated_successfully"),
              type: "success",
            });
            this.$emit("updated");
          } else if (response.status == 210) {
            this.$notify({
              text: this.$t("vpns.vpn_update_failed"),
              type: "error",
            });
            this.server_errors = response.data.errors;
            this.validated = false;
          }
        } else {
          const response = await axios.post("localvpn", this.selectedVpn);
          if (response.status === 200) {
            document.getElementById("add-vpn-close").click();
            this.$notify({
              text: this.$t("vpns.vpn_added_successfully"),
              type: "success",
            });
            this.$emit("updated");
          } else if (response.status == 210) {
            this.$notify({
              text: this.$t("vpns.vpn_add_failed"),
              type: "error",
            });
            this.server_errors = response.data.errors;
            this.validated = false;
          }
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.operation_failed"),
          type: "error",
        });
      }
      this.loading = false;
    },
    validate() {
      this.validated = true;
      this.errors.ip = null;
      this.errors.password = null;
      this.errors.username = null;
      if (!this.selectedVpn.username || this.selectedVpn.username.length < 3) {
        this.errors.username = this.$t(
          "errors.vpns.username_must_be_at_least_3_chars",
        );
        this.validated = false;
      }
      if (!this.selectedVpn.password || this.selectedVpn.password.length < 3) {
        this.errors.password = this.$t(
          "errors.vpns.password_must_be_at_least_3_chars",
        );
        this.validated = false;
      }
      if (
        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
          this.selectedVpn.ip,
        ) == false
      ) {
        this.errors.ip = this.$t("errors.vpns.invalid_ip");
        this.validated = false;
      }
    },
  },
};
</script>
